import React, { useRef } from "react";
import Content from "../Form/ScreenComponents/Content";
import PropTypes from "prop-types";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { List, ListItemText, ListItem, ListItemIcon } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { withStyles } from "@material-ui/core/styles";
import PathwayInfo from "../Form/ScreenComponents/Pathwayinfo";
import GeneralTips from "../Form/ScreenComponents/GeneralTips";
import ContractTips from "../Form/ScreenComponents/ContractTips";
import TailoringTipView from "../Form/ScreenComponents/TailoringTipView";
/*
https://github.com/gregnb/react-to-print/issues/324
*/
const useStyles = (theme) => ({
  headerClass: {
    color: "white",
    backgroundColor: theme.palette.primary.dark,
    padding: "15px",
    fontSize: "1em",
  },
  formContainer: {
    position: "relative",
    height: "auto",
    padding: "2rem",
  },
  gridcontainer: {
    alignItems: "center",
    justify: "center",
  },
  choiceClass: {
    color: "white",
    backgroundColor: theme.palette.primary.light,
  },
  pageBreak: {
    display: "none",
  },
  dialog: {
    backgroundColor: theme.palette.primary.dark,
  },
  formControl: {
    margin: theme.spacing(0),
    minWidth: 150,
  },
});

export class Printout extends React.Component {
  //let getDictVal = (cur_option, this.props.tailoringPayloadArrays.indexOf(cur_option), this.props.tailoringPayloadDicts)

  render() {
    const { classes } = this.props;
    const balancePaper = clsx(classes.paper, classes.balanceCard);
    let approachList = Object.keys(
      this.props.currentContext.approachDescriptions
    );

    let counter = [];

    let getLongApproaches = () => {
      let newArray = [];
      for (const approach of approachList) {
        if (
          this.props.currentContext.approachDescriptions[approach][
            "Recommended Tips"
          ].length >= 5 ||
          this.props.currentContext.approachDescriptions[approach][
            "Recommended Tips"
          ].length >= 5
        ) {
          newArray.push(approach);
        } else if (this.props.currentContext.approachChoice[approach]) {
          counter.push(approach);
        }
      }
      return newArray;
    };

    let longApproaches = getLongApproaches();
    console.log(longApproaches);

    console.log(approachList);
    let contract_dict = this.props.currentContext.contractDescriptions;
    let getDictVal = (option, index, dictArray, key) => {
      let relevant_dict = dictArray[index];
      return relevant_dict[option][key];
    };

    let getDescription = (curDict) => {
      return curDict["Resources"];
    };

    let getRecommended = (curDict) => {
      return curDict["Recommended Tips"];
    };

    let getNotRecommended = (curDict) => {
      return curDict["Not-Recommended Tips"];
    };

    return (
      <div className="print-container" style={{ margin: "0", padding: "0" }}>
        <Paper className={balancePaper}>
          <Grid
            container
            xs={12}
            spacing={0}
            direction="row"
            style={{
              justifyContent: "space-around",
              alignItems: "flex-start",
            }}
          >
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <h2>Project Information</h2>
            </Grid>
            <Grid item xs={6}>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Project Name:"
                    secondary={this.props.currentContext.projectName}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Project Nature:"
                    secondary={
                      this.props.currentContext.natureDescriptions[
                        this.props.currentContext.projectNature
                      ]
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Acquisition Pathway Choice:"
                    secondary={this.props.currentContext.getFullPathwayName()}
                  />
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={6}>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Urgent Project"
                    secondary={this.props.currentContext.getUrgencyText()}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="DBS Project:"
                    secondary={this.props.currentContext.getDBSText()}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="ACAT:"
                    secondary={this.props.currentContext.EstCosts}
                  />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Paper>

        <Paper className={balancePaper}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <h2>
              {this.props.currentContext.getFullPathwayName()} Description
            </h2>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justify="center"
              spacing={5}
              style={{ paddingTop: 20 }}
            >
              <PathwayInfo
                summary={
                  this.props.currentContext.pathwayInformation[
                    this.props.currentContext.scenarioGroup
                  ]["Summary"][this.props.currentContext.pathwayChoice]
                }
                benefits={
                  this.props.currentContext.pathwayInformation[
                    this.props.currentContext.scenarioGroup
                  ]["Benefit"][this.props.currentContext.pathwayChoice]
                }
                downsides={
                  this.props.currentContext.pathwayInformation[
                    this.props.currentContext.scenarioGroup
                  ]["Downside"][this.props.currentContext.pathwayChoice]
                }
                recommended={this.props.currentContext.isRecommended(
                  this.props.currentContext.pathwayChoice
                )}
              />
            </Grid>
          </Grid>
        </Paper>
        <div class="pagebreak" />
        {this.props.currentContext.printOptions["pathway"] && (
          <>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <GeneralTips
                printout={true}
                currentContext={this.props.currentContext}
              />
            </Grid>
            <div class="pagebreak" />
          </>
        )}
        {this.props.currentContext.printOptions["approach"] && (
          <>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <h2>Keep these tips in mind when applying your approaches</h2>
            </Grid>
            {approachList.map(
              (elem) =>
                this.props.currentContext.approachChoice[elem] && (
                  <>
                    <Grid item xs={12} key={approachList.indexOf(elem)}>
                      <Typography align="center">{elem}</Typography>
                      <Paper className={balancePaper}>
                        <Grid item xs={12}>
                          <div className={classes.column}>
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primary={getDescription(
                                    this.props.currentContext
                                      .approachDescriptions[elem]
                                  )}
                                />
                              </ListItem>
                            </List>
                          </div>
                        </Grid>
                        <Grid item container xs={12}>
                          {getRecommended(
                            this.props.currentContext.approachDescriptions[elem]
                          )[0] !== "" && (
                            <Grid item xs={6}>
                              <div className={clsx(classes.column)}>
                                <List dense>
                                  {getRecommended(
                                    this.props.currentContext
                                      .approachDescriptions[elem]
                                  ).map((recommended) => (
                                    <ListItem
                                      key={getRecommended(
                                        this.props.currentContext
                                          .approachDescriptions[elem]
                                      ).indexOf(recommended)}
                                    >
                                      <ListItemIcon>
                                        <AddIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={recommended} />
                                    </ListItem>
                                  ))}
                                </List>
                              </div>
                            </Grid>
                          )}
                          {getNotRecommended(
                            this.props.currentContext.approachDescriptions[elem]
                          )[0] !== "" && (
                            <Grid item xs={6}>
                              <div className={clsx(classes.column)}>
                                <List dense>
                                  {getNotRecommended(
                                    this.props.currentContext
                                      .approachDescriptions[elem]
                                  ).map((notRecommended) => (
                                    <ListItem
                                      key={getNotRecommended(
                                        this.props.currentContext
                                          .approachDescriptions[elem]
                                      ).indexOf(notRecommended)}
                                    >
                                      <ListItemIcon>
                                        <RemoveIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={notRecommended} />
                                    </ListItem>
                                  ))}
                                </List>
                              </div>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    </Grid>
                    {longApproaches.includes(elem) ? (
                      <div class="pagebreak" />
                    ) : (
                      counter.indexOf(elem) % 3 === 0 && (
                        <div class="pagebreak" />
                      )
                    )}
                  </>
                )
            )}
            <div class="pagebreak" />
          </>
        )}
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <h2>Keep these tips in mind for your tailoring selections</h2>
        </Grid>
        {this.props.currentContext.printOptions["tailor"] && (
          <div>
            {this.props.tailoringPayloadArrays.map((selected_type) => (
              <>
                {selected_type.map((cur_option) => (
                  <div>
                    <Grid item xs={12}>
                      <div>
                        <TailoringTipView
                          printout={true}
                          elem={cur_option}
                          tailoringDict={
                            this.props.tailoringPayloadDicts[
                              this.props.tailoringPayloadArrays.indexOf(
                                selected_type
                              )
                            ]
                          }
                          classes={classes}
                        />
                      </div>
                    </Grid>
                    <br />
                    {selected_type.indexOf(cur_option) % 2 === 0 && (
                      <div class="pagebreak" />
                    )}
                  </div>
                ))}
              </>
            ))}
          </div>
        )}
        <div class="pagebreak" />
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <h2>Keep these tips in mind for your contract selections</h2>
        </Grid>
        {this.props.currentContext.printOptions["contract"] && (
          <>
            <ContractTips
              currentContext={this.props.currentContext}
              balancePaper={balancePaper}
              printout={true}
            />
          </>
        )}
      </div>
    );
  }
}
export default withStyles(useStyles, { withTheme: true })(Printout);
